import React, { useState, useEffect, useCallback } from 'react';
import { ValidatorPass } from './PasswordValid.styles';

const PasswordValid = ({ password, confirmPassword }) => {
  //Password Validation
  const [upperValidated, setUpperValidated] = useState(false);
  const [numberValidated, setNumberValidated] = useState(false);
  const [specialValidated, setSpecialValidated] = useState(false);
  const [lengthValidated, setlengthValidated] = useState(false);
  const upper = new RegExp('^(?=.*[A-Z]).+$');
  const num = new RegExp('^(?=.*[0-9]).+$');
  const special = new RegExp('^(?=.*[_.@$%&-/#?¿*]).+$');
  const length = new RegExp('^.{8,}$');

  const validatorDataPassword = useCallback(() => {
    if (!password) {
      return;
    }
    setUpperValidated(upper.test(password));
    setNumberValidated(num.test(password));
    setSpecialValidated(special.test(password));
    setlengthValidated(length.test(password));
  }, [password, confirmPassword]);

  useEffect(() => {
    validatorDataPassword();
  }, [password, confirmPassword, validatorDataPassword]);

  return (
    <ValidatorPass>
      {password && (
        <>
          <p>
            {upperValidated ? (
              <img
                src="https://finsphera-webapp-resources.s3.amazonaws.com/icon_modal_success_value.png"
                alt="icono de acierto"
              />
            ) : (
              <img
                src="https://finsphera-webapp-resources.s3.amazonaws.com/icon_modal_error_value.png"
                alt="icono de error"
              />
            )}
            Debe tener una mayúscula
          </p>
          <p>
            {numberValidated ? (
              <img
                src="https://finsphera-webapp-resources.s3.amazonaws.com/icon_modal_success_value.png"
                alt="icono de acierto"
              />
            ) : (
              <img
                src="https://finsphera-webapp-resources.s3.amazonaws.com/icon_modal_error_value.png"
                alt="icono de error"
              />
            )}
            Debe tener al menos un número
          </p>
          <p>
            {specialValidated ? (
              <img
                src="https://finsphera-webapp-resources.s3.amazonaws.com/icon_modal_success_value.png"
                alt="icono de acierto"
              />
            ) : (
              <img
                src="https://finsphera-webapp-resources.s3.amazonaws.com/icon_modal_error_value.png"
                alt="icono de error"
              />
            )}
            Debe tener un caracter especial
          </p>
          <p>
            {lengthValidated ? (
              <img
                src="https://finsphera-webapp-resources.s3.amazonaws.com/icon_modal_success_value.png"
                alt="icono de acierto"
              />
            ) : (
              <img
                src="https://finsphera-webapp-resources.s3.amazonaws.com/icon_modal_error_value.png"
                alt="icono de error"
              />
            )}
            Mínimo 8 caracteres
          </p>
        </>
      )}
    </ValidatorPass>
  );
};

export default PasswordValid;
